"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconButton = void 0;
var stitches_config_1 = require("../stitches.config");
exports.IconButton = (0, stitches_config_1.styled)("button", {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    alignContent: "center",
    borderRadius: stitches_config_1.theme.shape.borderRadius,
    border: "none",
    cursor: "pointer",
    gap: "6px",
    "&:disabled": {
        opacity: 0.5,
        cursor: "not-allowed",
    },
    variants: {
        color: {
            gray: {
                background: stitches_config_1.theme.colors.gray3,
                borderColor: stitches_config_1.theme.colors.gray7,
                color: stitches_config_1.theme.colors.gray12,
                "&:hover": {
                    backgroundColor: stitches_config_1.theme.colors.gray4,
                },
                "&:active": {
                    backgroundColor: stitches_config_1.theme.colors.gray5,
                },
            },
            brand: {
                background: stitches_config_1.theme.colors.blue9,
                borderColor: stitches_config_1.theme.colors.blue7,
                color: stitches_config_1.theme.colors.blue11,
            },
            critical: {
                background: stitches_config_1.theme.colors.red9,
                borderColor: stitches_config_1.theme.colors.red7,
                color: stitches_config_1.theme.colors.red11,
            },
        },
        variant: {
            solid: {},
            outline: {
                background: stitches_config_1.theme.colors.white,
                borderWidth: "1px",
                borderStyle: "solid",
            },
            ghost: {
                background: "transparent",
            },
            inline: {
                padding: "0px",
                background: "transparent",
            },
        },
        size: {
            xs: {
                height: "28px",
                width: "28px",
                padding: "7.5px",
            },
            sm: {
                height: "32px",
                width: "32px",
                padding: "9.5px",
            },
        },
    },
    compoundVariants: [
        {
            variant: "inline",
            color: "gray",
            css: {
                color: stitches_config_1.theme.colors.gray11,
                background: "transparent",
                "&:hover": {
                    color: stitches_config_1.theme.colors.gray12,
                    background: "transparent",
                },
            },
        },
        {
            variant: "outline",
            color: "gray",
            css: {
                background: stitches_config_1.theme.colors.white,
                "&:hover": {
                    backgroundColor: stitches_config_1.theme.colors.gray2,
                    borderColor: stitches_config_1.theme.colors.gray8,
                },
                "&:active": {
                    backgroundColor: stitches_config_1.theme.colors.gray3,
                    borderColor: stitches_config_1.theme.colors.gray8,
                },
            },
        },
        {
            variant: "ghost",
            color: "gray",
            css: {
                background: "transparent",
            },
        },
        {
            variant: "outline",
            color: "brand",
            css: {
                background: stitches_config_1.theme.colors.white,
                "&:hover": {
                    backgroundColor: stitches_config_1.theme.colors.blue2,
                    borderColor: stitches_config_1.theme.colors.blue8,
                },
            },
        },
        {
            variant: "inline",
            color: "brand",
            css: {
                background: "transparent",
                "&:hover": {
                    color: stitches_config_1.theme.colors.gray12,
                },
            },
        },
        {
            variant: "solid",
            color: "brand",
            css: {
                color: stitches_config_1.theme.colors.white,
                "&:hover": {
                    backgroundColor: stitches_config_1.theme.colors.blue10,
                },
            },
        },
        {
            variant: "ghost",
            color: "brand",
            css: {
                "&:hover": {
                    backgroundColor: stitches_config_1.theme.colors.blue4,
                },
            },
        },
        {
            variant: "outline",
            color: "critical",
            css: {
                background: stitches_config_1.theme.colors.white,
                "&:hover": {
                    backgroundColor: stitches_config_1.theme.colors.red2,
                    borderColor: stitches_config_1.theme.colors.red8,
                },
            },
        },
        {
            variant: "solid",
            color: "critical",
            css: {
                color: stitches_config_1.theme.colors.white,
                "&:hover": {
                    backgroundColor: stitches_config_1.theme.colors.red10,
                },
            },
        },
        {
            variant: "inline",
            color: "critical",
            css: {
                background: "transparent",
                "&:hover": {
                    color: stitches_config_1.theme.colors.gray12,
                },
            },
        },
        {
            variant: "ghost",
            color: "critical",
            css: {
                background: "transparent",
                "&:hover": {
                    backgroundColor: stitches_config_1.theme.colors.red4,
                },
            },
        },
    ],
    defaultVariants: {
        color: "gray",
        variant: "solid",
        size: "sm",
    },
});
//# sourceMappingURL=IconButton.js.map